if (!customElements.get('product-recommendations')) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.slider = null;
    }

    connectedCallback() {
      // En mode produit forcé, la carte est déjà rendue côté serveur :
      // on initialise directement sans appel à l'API de recommandations.
      if (this.hasAttribute('data-forced')) {
        this.initForced();
      } else {
        this.performRecommendations();
      }
    }

    initForced() {
      this.classList.remove('hidden');
      const cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
      if (cartDrawerItemsFull) {
        cartDrawerItemsFull.classList.remove('cart-drawer-items__full');
      }
      this.initSlider();
      this.initAddToCart();
    }

    performRecommendations() {
      const recommendations = this.querySelector(
        '[data-recommendations]'
      );
      if (!recommendations) return;
      fetch(this.dataset.url)
        .then(response => response.text())
        .then(text => {
          const recommendationsHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('[data-recommendations]')?.innerHTML;
          if (!recommendationsHTML) return;
          this.classList.remove('hidden');
          var cartDrawerItemsFull = document.querySelector('.cart-drawer-items__full');
          if(cartDrawerItemsFull) {
            cartDrawerItemsFull.classList.remove('.cart-drawer-items__full');
          }
          recommendations.innerHTML = recommendationsHTML;
          this.initSlider();
          this.initAddToCart();
        });
    }

    // Branche les boutons d'ajout direct au panier (ajout en 1 clic via le variant id).
    initAddToCart() {
  // 购物车抽屉：使用事件委托，保证 drawer AJAX 重绘后按钮仍然可用
  if (this.dataset.recommendationArea === 'cart-drawer') {
    if (this._cartUpsellAddInitialized) return;

    this._cartUpsellAddInitialized = true;

    this.addEventListener('click', event => {
      const button = event.target.closest('[data-recommendations-add]');

      if (!button || !this.contains(button)) return;

      event.preventDefault();
      event.stopPropagation();

      this.addToCart(event, button);
    });

    return;
  }

  // 其他区域保持原来的逻辑
  this.querySelectorAll('[data-recommendations-add]').forEach(button => {
    if (button._init) return;

    button._init = true;
    button.addEventListener('click', event => this.addToCart(event, button));
  });
}

    // Ajoute la variante au panier puis rafraîchit (et ouvre) le panier.
    async addToCart(event, button) {
      event.preventDefault();
      event.stopPropagation();

      const variantId = button.dataset.variantId;
      if (!variantId || button.classList.contains('is--loading')) return;

      const cart =
        document.querySelector('cart-drawer') ||
        document.querySelector('cart-notification');

      const formData = new FormData();
      formData.append('id', variantId);
      formData.append('quantity', 1);
      if (cart && typeof cart.getSectionsToRender === 'function') {
        formData.append('sections', cart.getSectionsToRender().map(section => section.section).join(','));
        formData.append('sections_url', window.location.pathname);
      }

      button.classList.add('is--loading');
      try {
        const response = await fetch(`${routes.cart_add_url}`, {
          method: 'POST',
          headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
          body: formData
        });
        const data = await response.json();

        // En cas d'erreur (rupture de stock, etc.) on rafraîchit sans ouvrir.
        if (data.status) {
          if (cart && typeof cart.renderContents === 'function' && data.sections) {
            cart.renderContents(data, false);
          }
          return;
        }

        if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(data);
        } else {
          window.location.href = routes.cart_url;
        }
        if (typeof updateCartCounters === 'function') updateCartCounters();
      } catch (error) {
        console.error(error);
      } finally {
        button.classList.remove('is--loading');
      }
    }

    initSlider() {
      this.slider = new Swiper(this.querySelector('.swiper'), {
        slidesPerView: 'auto',
        spaceBetween: 16,
      });
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);
}
